import React from "react";
import { observer } from "mobx-react";
import { DateTime } from "luxon";
import { Event } from "@gp/models";

export const LiveMatchTime = observer(function LiveMatchTime(props: {
	event: Event;
}) {
	if (props.event.matchTime != undefined) {
		return <>{props.event.matchTime.displayTime}</>;
	}
	return <>{DateTime.fromISO(props.event.startTime).toFormat("HH:mm")}</>;
});
